
import Pdfs from "../../Pdfs";
import pdf from './arquivoPdf/certificado_javascript.pdf';


export default function Pdf01(){
    return(

        <Pdfs pdf={pdf} />

    )
}
